import { isNumberValid } from "../../utils";

const PercentageBadge = ({ value, isLoss, decimals = 0 }) => {
    if (!isNumberValid(value)) {
        return null;
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '0.5rem',
                fontSize: '0.75rem',
                padding: '0.25rem',
                border: `1px solid rgba(${isLoss ? 'var(--sf-red-rgb)' : 'var(--sf-green-rgb)'}, 44%)`,
                backgroundColor: `rgba(${isLoss ? 'var(--sf-red-rgb)' : 'var(--sf-green-rgb)'}, 12%)`,
                borderRadius: '6px',
                width: 'fit-content',
            }}
        >
            {value > 0 ? '+' : ''}{Number(value).toFixed(decimals)}%
        </div>
    );
};

export default PercentageBadge;
